
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oasis-home-energy-management-system",
      function () {
        return require("private-next-pages/oasis-home-energy-management-system/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oasis-home-energy-management-system"])
      });
    }
  